export default "__VITE_ASSET__CpPZzOtz__"